import { Return } from 'types/return';

const supportedResolutions = new Set([
  'REFUND',
  'ORIGINAL_PAYMENT',
  'STORE_CREDIT',
  'STORE_CREDIT_BONUS',
  'KEEP_ITEM_DISCOUNT',
]);

const normalize = (value: unknown) =>
  typeof value === 'string'
    ? value.trim().toUpperCase().replace(/[\s-]+/g, '_')
    : '';

export function getUnsupportedReturnResolutions(record?: Return | null): string[] {
  if (!record) return [];

  const requested = [
    record.requestedResolution,
    record.deflectionOption,
    ...(record.returnItems || []).map((item) => item.requestedResolution),
  ].map(normalize);
  // Historical outcomes and offer types include freeform notes and reward names.
  const unsupportedLegacyValues = [
    ...(record.returnItems || []).map((item) => item.resolution),
    record.meta?.selectedDeflectionOffer?.type,
  ].map(normalize).filter((value) => /^(EXCHANGE|REORDER)(_|$)/.test(value));

  return Array.from(new Set([...requested, ...unsupportedLegacyValues]))
    .filter((value) => value && !supportedResolutions.has(value));
}
